import {
    accountSourceDataTypeChecker,
    getAccountByMailboxInfo,
    getSelectedAccount,
} from 'owa-account-source-list-store';
import { isMonarchMultipleAccountsEnabled } from 'owa-account-source-list/lib/flights';
import type { MailboxInfo } from 'owa-client-types';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getStore } from 'owa-mail-store';
import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import type ItemId from 'owa-service/lib/contract/ItemId';
import type Message from 'owa-service/lib/contract/Message';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import getAlternativeFromAddress from './getAlternativeFromAddress';
import getSenderInRecipients from './getSenderInRecipients';

/**
 * Get the from address that should be shown in the From well
 * @param referenceItemId, the id for referencing the message
 */
export default function getFromAddressWrapper(
    mailboxInfo: MailboxInfo,
    referenceItemId?: ItemId
): EmailAddressWrapper {
    let fromAddress;
    if (referenceItemId) {
        const mailStore = getStore();
        const items = mailStore?.items;
        const referenceItem =
            items && items.has(referenceItemId.Id) && (items.get(referenceItemId.Id) as Message);
        fromAddress =
            referenceItem &&
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2345 (27,35): Argument of type 'EmailAddressWrapper[] | undefined' is not assignable to parameter of type 'EmailAddressWrapper[]'.
            // @ts-expect-error
            getSenderInRecipients(referenceItem.ToRecipients, referenceItem.CcRecipients);
    }

    if (!fromAddress && isMonarchMultipleAccountsEnabled()) {
        const selectedAccount = isFeatureEnabled('acct-noreflow')
            ? getAccountByMailboxInfo(mailboxInfo)
            : getSelectedAccount();
        const { emailAddress, displayName } = accountSourceDataTypeChecker.isM365Mailbox(
            selectedAccount
        )
            ? selectedAccount.m365mailbox
            : { emailAddress: undefined, displayName: undefined };

        if (emailAddress && displayName) {
            return <EmailAddressWrapper>{
                MailboxType: 'Mailbox',
                RoutingType: 'SMTP',
                EmailAddress: emailAddress,
                Name: displayName,
            };
        }
    }

    return <EmailAddressWrapper>{
        MailboxType: 'Mailbox',
        RoutingType: 'SMTP',
        EmailAddress: fromAddress || getAlternativeFromAddress(),
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (51,15): Object is possibly 'undefined'.
        // @ts-expect-error
        Name: getUserConfiguration().SessionSettings.UserDisplayName,
    };
}
